import { addOpacityToRGBA } from 'common/utils/color-utils'
import { fontCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

export const CommonBookingCalendarStepsUi = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

interface CommonBookingCalendarStepItemUiProps {
  isActive: boolean
  activeColor: string
  textColor?: string
  side?: 'left' | 'right'
}

export const CommonBookingCalendarStepItemUi = styled.div<CommonBookingCalendarStepItemUiProps>`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 5px;

  padding: 20px 10px;
  border-radius: ${({ side = 'left' }) => (side === 'left' ? '10px 0 0 10px' : '0 10px 10px 0')};

  border: 1px solid #b5c3d580;

  ${fontCss}

  background-color: ${p =>
    p.isActive ? addOpacityToRGBA(p.activeColor, 0.1) : 'inherit'};

  border-color: ${p => (p.isActive ? p.activeColor : '#b5c3d580')};

  & > span {
    color: ${p => p.textColor};
    font-weight: 600;
    font-size: 16px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      padding: 5px;
      gap: 2px;
    `}

  font-size: 14px;

  ${p => p.theme.phone} {
    padding: 5px;
    gap: 2px;
  }
`
